var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.93,66.23c7.19,0,128.17.8,135.78.56.54,0,.84-.82.29-1.09-4.79-2.38-10.23-1.9-15.21-3.58-2.93-1-4.73-2.9-6.76-5.1a14,14,0,0,0-6.3-4.11,13.26,13.26,0,0,0-6.85-.21c-2.46.58-4.59,2-6.93,2.87-5.81,2.2-11.46.11-15.61-4.19-3.42-3.54-6.78-6.89-11.44-8.8a15.16,15.16,0,0,0-12.12-.16c-4.43,2-7.48,6-11.65,8.48-4.94,2.89-10.85,2.21-16.3,3.08s-9.65,5.46-14.44,8.11a10.24,10.24,0,0,1-5.22,1.62c-1.07,0-2.12-.32-3.17-.45-1.65-.2-3.22-.16-4.32,1.22C474.41,64.81,474.46,66.23,474.93,66.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.77,82.52c5.24,0,93.57.58,99.12.4.4,0,.62-.6.22-.8-3.5-1.73-7.47-1.38-11.11-2.61-2.14-.72-3.45-2.12-4.93-3.72a10.25,10.25,0,0,0-4.6-3,9.75,9.75,0,0,0-5-.16c-1.8.43-3.35,1.46-5.06,2.1-4.25,1.6-8.37.08-11.4-3.06-2.5-2.58-5-5-8.35-6.42a11.08,11.08,0,0,0-8.85-.12c-3.24,1.46-5.46,4.42-8.5,6.19-3.61,2.11-7.93,1.61-11.91,2.25s-7,4-10.54,5.92a7.42,7.42,0,0,1-3.81,1.18,22.72,22.72,0,0,1-2.32-.33c-1.2-.14-2.34-.11-3.15.89C43.38,81.48,43.42,82.52,43.77,82.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.77,139.68c5.25,0,93.58.59,99.13.41.4,0,.61-.6.22-.8-3.5-1.73-7.47-1.38-11.11-2.61-2.14-.72-3.45-2.12-4.94-3.72a10.22,10.22,0,0,0-4.59-3,9.68,9.68,0,0,0-5-.16c-1.79.43-3.34,1.46-5.05,2.1-4.25,1.6-8.37.08-11.4-3.06-2.5-2.59-5-5-8.35-6.42a11.08,11.08,0,0,0-8.85-.12c-3.24,1.46-5.46,4.42-8.51,6.19-3.6,2.11-7.92,1.61-11.9,2.25s-7.05,4-10.54,5.92a7.52,7.52,0,0,1-3.81,1.18,22.72,22.72,0,0,1-2.32-.33,3.17,3.17,0,0,0-3.15.89C296.39,138.65,296.43,139.68,296.77,139.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607,137.21c5.24,0,93.57.58,99.12.41.4,0,.62-.6.22-.8-3.5-1.73-7.47-1.38-11.1-2.61-2.14-.72-3.46-2.12-4.94-3.72a10.25,10.25,0,0,0-4.6-3,9.64,9.64,0,0,0-5-.16c-1.8.43-3.35,1.45-5.06,2.1-4.24,1.6-8.37.08-11.4-3.06-2.5-2.59-5-5-8.35-6.42a11.12,11.12,0,0,0-8.85-.13c-3.24,1.47-5.46,4.42-8.5,6.2-3.61,2.11-7.93,1.61-11.91,2.24s-7,4-10.54,5.93a7.49,7.49,0,0,1-3.81,1.18A22.72,22.72,0,0,1,610,135a3.17,3.17,0,0,0-3.15.89C606.6,136.17,606.64,137.21,607,137.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.76,186.56c.1.3,139.21,0,137.46,0-.8,0,1.21-1.19.43-1.58-4.53-2.25-9.49-2.31-14.42-2.76a22.08,22.08,0,0,1-8.42-2.05c-2.62-1.37-4.25-3.75-6.12-5.95a26.1,26.1,0,0,0-23.75-9c-9.89,1.54-17.69,9.08-27.6,10.47-5.95.83-11.58-1.47-17.4-2.29a21.32,21.32,0,0,0-13.06,2.39c-3.14,1.56-6,2.87-9.59,3.11-2.72.2-5.46-.12-8.18-.14a18.34,18.34,0,0,0-12.05,4.81C226.61,184,225.21,186.56,229.76,186.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.86,
    y: 108.71,
    width: 57.48,
    height: 301.31,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.78,
    y: 118.49,
    width: 11.17,
    height: 11.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.08,
    y: 118.49,
    width: 11.17,
    height: 11.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.78,
    y: 138.03,
    width: 11.17,
    height: 11.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.08,
    y: 138.03,
    width: 11.17,
    height: 11.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.78,
    y: 157.56,
    width: 11.17,
    height: 11.51,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.08,
    y: 157.56,
    width: 11.17,
    height: 11.51,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.78,
    y: 177.09,
    width: 11.17,
    height: 11.51,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.08,
    y: 177.09,
    width: 11.17,
    height: 11.51,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.78,
    y: 196.63,
    width: 11.17,
    height: 11.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.08,
    y: 196.63,
    width: 11.17,
    height: 11.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.78,
    y: 216.16,
    width: 11.17,
    height: 11.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.08,
    y: 216.16,
    width: 11.17,
    height: 11.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.78,
    y: 235.69,
    width: 11.17,
    height: 11.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.08,
    y: 235.69,
    width: 11.17,
    height: 11.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.78,
    y: 255.22,
    width: 11.17,
    height: 11.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.08,
    y: 255.22,
    width: 11.17,
    height: 11.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.78,
    y: 274.76,
    width: 11.17,
    height: 11.51,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.08,
    y: 274.76,
    width: 11.17,
    height: 11.51,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.78,
    y: 294.29,
    width: 11.17,
    height: 11.51,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.08,
    y: 294.29,
    width: 11.17,
    height: 11.51,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.78,
    y: 313.82,
    width: 11.17,
    height: 11.51,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.08,
    y: 313.82,
    width: 11.17,
    height: 11.51,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.78,
    y: 333.35,
    width: 11.17,
    height: 11.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.08,
    y: 333.35,
    width: 11.17,
    height: 11.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.78,
    y: 352.89,
    width: 11.17,
    height: 11.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.08,
    y: 352.89,
    width: 11.17,
    height: 11.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.78,
    y: 372.42,
    width: 11.17,
    height: 11.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.25,
    y: 372.42,
    width: 11.17,
    height: 11.5,
    transform: "translate(1141.67 756.35) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.25,
    y: 352.89,
    width: 11.17,
    height: 11.5,
    transform: "translate(1141.67 717.28) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.25,
    y: 333.35,
    width: 11.17,
    height: 11.5,
    transform: "translate(1141.67 678.21) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.25,
    y: 313.82,
    width: 11.17,
    height: 11.51,
    transform: "translate(1141.67 639.15) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.25,
    y: 294.29,
    width: 11.17,
    height: 11.51,
    transform: "translate(1141.67 600.08) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.25,
    y: 274.76,
    width: 11.17,
    height: 11.51,
    transform: "translate(1141.67 561.02) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.25,
    y: 255.22,
    width: 11.17,
    height: 11.5,
    transform: "translate(1141.67 521.95) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.25,
    y: 235.69,
    width: 11.17,
    height: 11.5,
    transform: "translate(1141.67 482.89) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.25,
    y: 216.16,
    width: 11.17,
    height: 11.5,
    transform: "translate(1141.67 443.82) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.25,
    y: 196.63,
    width: 11.17,
    height: 11.5,
    transform: "translate(1141.67 404.76) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.25,
    y: 177.09,
    width: 11.17,
    height: 11.51,
    transform: "translate(1141.67 365.69) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.25,
    y: 157.56,
    width: 11.17,
    height: 11.51,
    transform: "translate(1141.67 326.62) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.25,
    y: 138.03,
    width: 11.17,
    height: 11.5,
    transform: "translate(1141.67 287.56) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.25,
    y: 118.49,
    width: 11.17,
    height: 11.5,
    transform: "translate(1141.67 248.49) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.08,
    y: 372.42,
    width: 11.17,
    height: 11.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 585.34,
    y: 108.71,
    width: 45.32,
    height: 301.31,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.76,
    y: 372.42,
    width: 9.23,
    height: 11.5,
    transform: "translate(1242.75 756.35) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 604.96,
    y: 372.42,
    width: 9.23,
    height: 11.5,
    transform: "translate(1219.14 756.35) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.76,
    y: 352.89,
    width: 9.23,
    height: 11.5,
    transform: "translate(1242.75 717.28) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 604.96,
    y: 352.89,
    width: 9.23,
    height: 11.5,
    transform: "translate(1219.14 717.28) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.76,
    y: 333.35,
    width: 9.23,
    height: 11.5,
    transform: "translate(1242.75 678.21) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 604.96,
    y: 333.35,
    width: 9.23,
    height: 11.5,
    transform: "translate(1219.14 678.21) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.76,
    y: 313.82,
    width: 9.23,
    height: 11.51,
    transform: "translate(1242.75 639.15) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 604.96,
    y: 313.82,
    width: 9.23,
    height: 11.51,
    transform: "translate(1219.14 639.15) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.76,
    y: 294.29,
    width: 9.23,
    height: 11.51,
    transform: "translate(1242.75 600.08) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 604.96,
    y: 294.29,
    width: 9.23,
    height: 11.51,
    transform: "translate(1219.14 600.08) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.76,
    y: 274.76,
    width: 9.23,
    height: 11.51,
    transform: "translate(1242.75 561.02) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 604.96,
    y: 274.76,
    width: 9.23,
    height: 11.51,
    transform: "translate(1219.14 561.02) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.76,
    y: 255.22,
    width: 9.23,
    height: 11.5,
    transform: "translate(1242.75 521.95) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 604.96,
    y: 255.22,
    width: 9.23,
    height: 11.5,
    transform: "translate(1219.14 521.95) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.76,
    y: 235.69,
    width: 9.23,
    height: 11.5,
    transform: "translate(1242.75 482.89) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 604.96,
    y: 235.69,
    width: 9.23,
    height: 11.5,
    transform: "translate(1219.14 482.89) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.76,
    y: 216.16,
    width: 9.23,
    height: 11.5,
    transform: "translate(1242.75 443.82) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 604.96,
    y: 216.16,
    width: 9.23,
    height: 11.5,
    transform: "translate(1219.14 443.82) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.76,
    y: 196.63,
    width: 9.23,
    height: 11.5,
    transform: "translate(1242.75 404.76) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 604.96,
    y: 196.63,
    width: 9.23,
    height: 11.5,
    transform: "translate(1219.14 404.76) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.76,
    y: 177.09,
    width: 9.23,
    height: 11.51,
    transform: "translate(1242.75 365.69) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 604.96,
    y: 177.09,
    width: 9.23,
    height: 11.51,
    transform: "translate(1219.14 365.69) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.76,
    y: 157.56,
    width: 9.23,
    height: 11.51,
    transform: "translate(1242.75 326.62) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 604.96,
    y: 157.56,
    width: 9.23,
    height: 11.51,
    transform: "translate(1219.14 326.62) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.76,
    y: 138.03,
    width: 9.23,
    height: 11.5,
    transform: "translate(1242.75 287.56) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 604.96,
    y: 138.03,
    width: 9.23,
    height: 11.5,
    transform: "translate(1219.14 287.56) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.76,
    y: 118.49,
    width: 9.23,
    height: 11.5,
    transform: "translate(1242.75 248.49) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.26,
    y: 118.49,
    width: 9.23,
    height: 11.5,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.26,
    y: 138.03,
    width: 9.23,
    height: 11.5,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.26,
    y: 157.56,
    width: 9.23,
    height: 11.51,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.26,
    y: 177.09,
    width: 9.23,
    height: 11.51,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.26,
    y: 196.63,
    width: 9.23,
    height: 11.5,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.26,
    y: 216.16,
    width: 9.23,
    height: 11.5,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.26,
    y: 235.69,
    width: 9.23,
    height: 11.5,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.26,
    y: 255.22,
    width: 9.23,
    height: 11.5,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.26,
    y: 274.76,
    width: 9.23,
    height: 11.51,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.26,
    y: 294.29,
    width: 9.23,
    height: 11.51,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.26,
    y: 313.82,
    width: 9.23,
    height: 11.51,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.26,
    y: 333.35,
    width: 9.23,
    height: 11.5,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.26,
    y: 352.89,
    width: 9.23,
    height: 11.5,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.26,
    y: 372.42,
    width: 9.23,
    height: 11.5,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 604.96,
    y: 118.49,
    width: 9.23,
    height: 11.5,
    transform: "translate(1219.14 248.49) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.23,
    y: 85.34,
    width: 69.2,
    height: 324.68,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.57,
    y: 78.87,
    width: 70.86,
    height: 6.47,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.49,
    y: 94.87,
    width: 7.01,
    height: 315.15,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.91,
    y: 94.87,
    width: 7.01,
    height: 315.15,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.33,
    y: 94.87,
    width: 7.01,
    height: 315.15,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.74,
    y: 94.87,
    width: 7.01,
    height: 315.15,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.16,
    y: 94.87,
    width: 7.01,
    height: 315.15,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.49,
    y: 103.03,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.91,
    y: 103.03,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.33,
    y: 103.03,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.74,
    y: 103.03,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.16,
    y: 103.03,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.49,
    y: 123.78,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.91,
    y: 123.78,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.33,
    y: 123.78,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.74,
    y: 123.78,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.16,
    y: 123.78,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.49,
    y: 144.52,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.91,
    y: 144.52,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.33,
    y: 144.52,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.74,
    y: 144.52,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.16,
    y: 144.52,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.49,
    y: 165.26,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.91,
    y: 165.26,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.33,
    y: 165.26,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.74,
    y: 165.26,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.16,
    y: 165.26,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.49,
    y: 186,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.91,
    y: 186,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.33,
    y: 186,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.74,
    y: 186,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.16,
    y: 186,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.49,
    y: 206.75,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.91,
    y: 206.75,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.33,
    y: 206.75,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.74,
    y: 206.75,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.16,
    y: 206.75,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.49,
    y: 227.49,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.91,
    y: 227.49,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.33,
    y: 227.49,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.74,
    y: 227.49,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.16,
    y: 227.49,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.49,
    y: 248.23,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.91,
    y: 248.23,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.33,
    y: 248.23,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.74,
    y: 248.23,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.16,
    y: 248.23,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.49,
    y: 268.97,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.91,
    y: 268.97,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.33,
    y: 268.97,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.74,
    y: 268.97,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.16,
    y: 268.97,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.49,
    y: 289.72,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.91,
    y: 289.72,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.33,
    y: 289.72,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.74,
    y: 289.72,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.16,
    y: 289.72,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.49,
    y: 310.46,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.91,
    y: 310.46,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.33,
    y: 310.46,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.74,
    y: 310.46,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.16,
    y: 310.46,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.49,
    y: 331.2,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.91,
    y: 331.2,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.33,
    y: 331.2,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.74,
    y: 331.2,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.16,
    y: 331.2,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.49,
    y: 351.94,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.91,
    y: 351.94,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.33,
    y: 351.94,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.74,
    y: 351.94,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.16,
    y: 351.94,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.49,
    y: 372.69,
    width: 7.01,
    height: 37.33,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.91,
    y: 372.69,
    width: 7.01,
    height: 37.33,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.33,
    y: 372.69,
    width: 7.01,
    height: 37.33,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.74,
    y: 372.69,
    width: 7.01,
    height: 37.33,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.16,
    y: 372.69,
    width: 7.01,
    height: 37.33,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.43,
    y: 85.34,
    width: 44.42,
    height: 324.68,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.43,
    y: 78.87,
    width: 46.35,
    height: 6.47,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.69,
    y: 94.87,
    width: 7.01,
    height: 315.15,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 94.87,
    width: 7.01,
    height: 315.15,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.52,
    y: 94.87,
    width: 7.01,
    height: 315.15,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.69,
    y: 103.03,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 103.03,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.52,
    y: 103.03,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.69,
    y: 123.78,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 123.78,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.52,
    y: 123.78,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.69,
    y: 144.52,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 144.52,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.52,
    y: 144.52,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.69,
    y: 165.26,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 165.26,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.52,
    y: 165.26,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.69,
    y: 186,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 186,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.52,
    y: 186,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.69,
    y: 206.75,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 206.75,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.52,
    y: 206.75,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.69,
    y: 227.49,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 227.49,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.52,
    y: 227.49,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.69,
    y: 248.23,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 248.23,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.52,
    y: 248.23,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.69,
    y: 268.97,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 268.97,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.52,
    y: 268.97,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.69,
    y: 289.72,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 289.72,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.52,
    y: 289.72,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.69,
    y: 310.46,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 310.46,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.52,
    y: 310.46,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.69,
    y: 331.2,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 331.2,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.52,
    y: 331.2,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.69,
    y: 351.94,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 351.94,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.52,
    y: 351.94,
    width: 7.01,
    height: 12.76,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.69,
    y: 372.69,
    width: 7.01,
    height: 37.33,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.1,
    y: 372.69,
    width: 7.01,
    height: 37.33,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.52,
    y: 372.69,
    width: 7.01,
    height: 37.33,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.77,
    y: 194.34,
    width: 56.87,
    height: 215.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.86,
    y: 180.04,
    width: 48.78,
    height: 14.3,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 201.81,
    width: 44.4,
    height: 161.23,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 217.2,
    width: 44.4,
    height: 3.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 232.98,
    width: 44.4,
    height: 3.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 248.76,
    width: 44.4,
    height: 3.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 264.54,
    width: 44.4,
    height: 3.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 280.32,
    width: 44.4,
    height: 3.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 296.1,
    width: 44.4,
    height: 3.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 311.88,
    width: 44.4,
    height: 3.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 327.67,
    width: 44.4,
    height: 3.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 343.45,
    width: 44.4,
    height: 3.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 359.23,
    width: 44.4,
    height: 3.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.64,
    y: 194.34,
    width: 35.62,
    height: 215.67,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.64,
    y: 180.04,
    width: 30.27,
    height: 14.3,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.55,
    y: 201.81,
    width: 27.39,
    height: 161.23,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.55,
    y: 217.2,
    width: 27.39,
    height: 3.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.55,
    y: 232.98,
    width: 27.39,
    height: 3.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.55,
    y: 248.76,
    width: 27.39,
    height: 3.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.55,
    y: 264.54,
    width: 27.39,
    height: 3.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.55,
    y: 280.32,
    width: 27.39,
    height: 3.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.55,
    y: 296.1,
    width: 27.39,
    height: 3.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.55,
    y: 311.88,
    width: 27.39,
    height: 3.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.55,
    y: 327.67,
    width: 27.39,
    height: 3.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.55,
    y: 343.45,
    width: 27.39,
    height: 3.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.55,
    y: 359.23,
    width: 27.39,
    height: 3.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 633.97,
    y: 197.98,
    width: 30.37,
    height: 35.88,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 664.34,
    y: 197.98,
    width: 19.26,
    height: 37.19,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 665.77,
    y: 213.82,
    width: 19.11,
    height: 21.35,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.88,
    y: 213.82,
    width: 11.92,
    height: 21.35,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 622.32,
    y: 231.53,
    width: 49.11,
    height: 178.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.94,
    y: 239.2,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.69,
    y: 239.2,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.94,
    y: 249.91,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.69,
    y: 249.91,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.94,
    y: 260.63,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.69,
    y: 260.63,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.94,
    y: 271.34,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.69,
    y: 271.34,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.94,
    y: 282.05,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.69,
    y: 282.05,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.94,
    y: 292.77,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.69,
    y: 292.77,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.94,
    y: 303.48,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.69,
    y: 303.48,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.94,
    y: 314.19,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.69,
    y: 314.19,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.94,
    y: 324.91,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.69,
    y: 324.91,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.94,
    y: 335.62,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.69,
    y: 335.62,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.94,
    y: 346.33,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.69,
    y: 346.33,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.94,
    y: 357.05,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.69,
    y: 357.05,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.94,
    y: 367.76,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.69,
    y: 367.76,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.94,
    y: 378.47,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.69,
    y: 378.47,
    width: 15.44,
    height: 6.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671.43,
    y: 231.53,
    width: 39.8,
    height: 178.49,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694.56,
    y: 378.47,
    width: 12.68,
    height: 6.31,
    transform: "translate(1401.8 763.26) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.34,
    y: 378.47,
    width: 12.68,
    height: 6.31,
    transform: "translate(1369.36 763.26) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694.56,
    y: 367.76,
    width: 12.68,
    height: 6.31,
    transform: "translate(1401.8 741.83) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.34,
    y: 367.76,
    width: 12.68,
    height: 6.31,
    transform: "translate(1369.36 741.83) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694.56,
    y: 357.05,
    width: 12.68,
    height: 6.31,
    transform: "translate(1401.8 720.41) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.34,
    y: 357.05,
    width: 12.68,
    height: 6.31,
    transform: "translate(1369.36 720.41) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694.56,
    y: 346.33,
    width: 12.68,
    height: 6.31,
    transform: "translate(1401.8 698.98) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.34,
    y: 346.33,
    width: 12.68,
    height: 6.31,
    transform: "translate(1369.36 698.98) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694.56,
    y: 335.62,
    width: 12.68,
    height: 6.31,
    transform: "translate(1401.8 677.55) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.34,
    y: 335.62,
    width: 12.68,
    height: 6.31,
    transform: "translate(1369.36 677.55) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694.56,
    y: 324.91,
    width: 12.68,
    height: 6.31,
    transform: "translate(1401.8 656.12) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.34,
    y: 324.91,
    width: 12.68,
    height: 6.31,
    transform: "translate(1369.36 656.12) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694.56,
    y: 314.19,
    width: 12.68,
    height: 6.31,
    transform: "translate(1401.8 634.7) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.34,
    y: 314.19,
    width: 12.68,
    height: 6.31,
    transform: "translate(1369.36 634.7) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694.56,
    y: 303.48,
    width: 12.68,
    height: 6.31,
    transform: "translate(1401.8 613.27) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.34,
    y: 303.48,
    width: 12.68,
    height: 6.31,
    transform: "translate(1369.36 613.27) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694.56,
    y: 292.77,
    width: 12.68,
    height: 6.31,
    transform: "translate(1401.8 591.84) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.34,
    y: 292.77,
    width: 12.68,
    height: 6.31,
    transform: "translate(1369.36 591.84) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694.56,
    y: 282.05,
    width: 12.68,
    height: 6.31,
    transform: "translate(1401.8 570.42) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.34,
    y: 282.05,
    width: 12.68,
    height: 6.31,
    transform: "translate(1369.36 570.42) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694.56,
    y: 271.34,
    width: 12.68,
    height: 6.31,
    transform: "translate(1401.8 548.99) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.34,
    y: 271.34,
    width: 12.68,
    height: 6.31,
    transform: "translate(1369.36 548.99) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694.56,
    y: 260.63,
    width: 12.68,
    height: 6.31,
    transform: "translate(1401.8 527.56) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.34,
    y: 260.63,
    width: 12.68,
    height: 6.31,
    transform: "translate(1369.36 527.56) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694.56,
    y: 249.91,
    width: 12.68,
    height: 6.31,
    transform: "translate(1401.8 506.13) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.34,
    y: 249.91,
    width: 12.68,
    height: 6.31,
    transform: "translate(1369.36 506.13) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694.56,
    y: 239.2,
    width: 12.68,
    height: 6.31,
    transform: "translate(1401.8 484.71) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.34,
    y: 239.2,
    width: 12.68,
    height: 6.31,
    transform: "translate(1369.36 484.71) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.47,
    y: 293.71,
    width: 57.93,
    height: 116.31,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.58,
    y: 303.78,
    width: 10.25,
    height: 7.13,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.58,
    y: 319,
    width: 10.25,
    height: 7.13,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.58,
    y: 334.22,
    width: 10.25,
    height: 7.13,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.58,
    y: 349.44,
    width: 10.25,
    height: 7.13,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.58,
    y: 364.66,
    width: 10.25,
    height: 7.13,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.58,
    y: 379.88,
    width: 10.25,
    height: 7.13,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.58,
    y: 395.1,
    width: 10.25,
    height: 7.13,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.33,
    y: 303.78,
    width: 10.25,
    height: 7.13,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.33,
    y: 319,
    width: 10.25,
    height: 7.13,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.33,
    y: 334.22,
    width: 10.25,
    height: 7.13,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.33,
    y: 349.44,
    width: 10.25,
    height: 7.13,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.33,
    y: 364.66,
    width: 10.25,
    height: 7.13,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.33,
    y: 379.88,
    width: 10.25,
    height: 7.13,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.33,
    y: 395.1,
    width: 10.25,
    height: 7.13,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.04,
    y: 303.78,
    width: 10.25,
    height: 7.13,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.04,
    y: 319,
    width: 10.25,
    height: 7.13,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.04,
    y: 334.22,
    width: 10.25,
    height: 7.13,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.04,
    y: 349.44,
    width: 10.25,
    height: 7.13,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.04,
    y: 364.66,
    width: 10.25,
    height: 7.13,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.04,
    y: 379.88,
    width: 10.25,
    height: 7.13,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.04,
    y: 395.1,
    width: 10.25,
    height: 7.13,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.83,
    y: 281.59,
    width: 38.57,
    height: 12.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.95,
    y: 274.09,
    width: 24.45,
    height: 7.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.4,
    y: 293.71,
    width: 40.64,
    height: 116.31,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.54,
    y: 393.96,
    width: 8.34,
    height: 7.13,
    transform: "translate(673.42 795.04) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.54,
    y: 378.74,
    width: 8.34,
    height: 7.13,
    transform: "translate(673.42 764.6) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.54,
    y: 363.52,
    width: 8.34,
    height: 7.13,
    transform: "translate(673.42 734.16) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.54,
    y: 348.3,
    width: 8.34,
    height: 7.13,
    transform: "translate(673.42 703.73) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.54,
    y: 333.08,
    width: 8.34,
    height: 7.13,
    transform: "translate(673.42 673.29) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.54,
    y: 317.86,
    width: 8.34,
    height: 7.13,
    transform: "translate(673.42 642.85) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.54,
    y: 302.64,
    width: 8.34,
    height: 7.13,
    transform: "translate(673.42 612.41) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.53,
    y: 393.96,
    width: 8.34,
    height: 7.13,
    transform: "translate(649.41 795.04) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.53,
    y: 378.74,
    width: 8.34,
    height: 7.13,
    transform: "translate(649.41 764.6) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.53,
    y: 363.52,
    width: 8.34,
    height: 7.13,
    transform: "translate(649.41 734.16) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.53,
    y: 348.3,
    width: 8.34,
    height: 7.13,
    transform: "translate(649.41 703.73) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.53,
    y: 333.08,
    width: 8.34,
    height: 7.13,
    transform: "translate(649.41 673.29) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.53,
    y: 317.86,
    width: 8.34,
    height: 7.13,
    transform: "translate(649.41 642.85) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.53,
    y: 302.64,
    width: 8.34,
    height: 7.13,
    transform: "translate(649.41 612.41) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.56,
    y: 393.96,
    width: 8.34,
    height: 7.13,
    transform: "translate(625.47 795.04) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.56,
    y: 378.74,
    width: 8.34,
    height: 7.13,
    transform: "translate(625.47 764.6) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.56,
    y: 363.52,
    width: 8.34,
    height: 7.13,
    transform: "translate(625.47 734.16) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.56,
    y: 348.3,
    width: 8.34,
    height: 7.13,
    transform: "translate(625.47 703.73) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.56,
    y: 333.08,
    width: 8.34,
    height: 7.13,
    transform: "translate(625.47 673.29) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.56,
    y: 317.86,
    width: 8.34,
    height: 7.13,
    transform: "translate(625.47 642.85) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.56,
    y: 302.64,
    width: 8.34,
    height: 7.13,
    transform: "translate(625.47 612.41) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.4,
    y: 281.59,
    width: 34.49,
    height: 12.12,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.4,
    y: 274.09,
    width: 18.69,
    height: 7.5,
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--City--inject-21"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "218.15 410.02 160.92 410.02 160.92 230.49 218.15 193.4 218.15 410.02",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.8 410.02 167.36 410.02 167.36 235.51 210.8 207.36 210.8 410.02",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.8 410.02 167.36 410.02 167.36 235.51 210.8 207.36 210.8 410.02",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.34,
    y: 238.53,
    width: 38.46,
    height: 1.38,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.34,
    y: 249.87,
    width: 38.46,
    height: 1.38,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.34,
    y: 261.21,
    width: 38.46,
    height: 1.38,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.34,
    y: 272.55,
    width: 38.46,
    height: 1.38,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.34,
    y: 283.89,
    width: 38.46,
    height: 1.38,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.34,
    y: 295.23,
    width: 38.46,
    height: 1.38,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.34,
    y: 306.57,
    width: 38.46,
    height: 1.38,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.34,
    y: 317.91,
    width: 38.46,
    height: 1.38,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.34,
    y: 329.25,
    width: 38.46,
    height: 1.38,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.34,
    y: 340.59,
    width: 38.46,
    height: 1.38,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.34,
    y: 351.93,
    width: 38.46,
    height: 1.38,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.34,
    y: 363.27,
    width: 38.46,
    height: 1.38,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.34,
    y: 374.61,
    width: 38.46,
    height: 1.38,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.34,
    y: 385.95,
    width: 38.46,
    height: 1.38,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.34,
    y: 397.29,
    width: 38.46,
    height: 1.38,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.34,
    y: 408.63,
    width: 38.46,
    height: 1.38,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.23,
    y: 316.99,
    width: 184.66,
    height: 1.38,
    transform: "translate(-126.12 509.25) rotate(-90)",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.8 207.36 210.8 213.6 172.34 238.53 172.34 410.02 167.37 410.02 167.37 235.5 210.8 207.36",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.8 207.36 210.8 213.6 172.34 238.53 172.34 410.02 167.37 410.02 167.37 235.5 210.8 207.36",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.15,
    y: 193.4,
    width: 50.42,
    height: 216.62,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.15,
    y: 193.4,
    width: 50.42,
    height: 216.62,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 223.04,
    y: 207.36,
    width: 40.63,
    height: 4.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 223.04,
    y: 218.47,
    width: 40.63,
    height: 4.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 223.04,
    y: 229.58,
    width: 40.63,
    height: 4.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 223.04,
    y: 240.68,
    width: 40.63,
    height: 4.9
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 223.04,
    y: 251.79,
    width: 40.63,
    height: 4.9
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 223.04,
    y: 262.9,
    width: 40.63,
    height: 4.9
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 223.04,
    y: 274.01,
    width: 40.63,
    height: 4.9
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 223.04,
    y: 285.12,
    width: 40.63,
    height: 4.9
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 223.04,
    y: 296.23,
    width: 40.63,
    height: 4.9
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 223.04,
    y: 307.34,
    width: 40.63,
    height: 4.9
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 223.04,
    y: 318.45,
    width: 40.63,
    height: 4.9
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 223.04,
    y: 329.55,
    width: 40.63,
    height: 4.9
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 223.04,
    y: 340.66,
    width: 40.63,
    height: 4.9
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 223.04,
    y: 351.77,
    width: 40.63,
    height: 4.9
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 223.04,
    y: 362.88,
    width: 40.63,
    height: 4.9
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 223.04,
    y: 373.99,
    width: 40.63,
    height: 4.9
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 223.04,
    y: 385.1,
    width: 40.63,
    height: 4.9
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 223.04,
    y: 396.21,
    width: 40.63,
    height: 4.9
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 583.61,
    y: 198.68,
    width: 68.83,
    height: 211.34,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600.68,
    y: 177.42,
    width: 51.5,
    height: 21.26,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 604.97,
    y: 180.7,
    width: 4.4,
    height: 14.7,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 612.67,
    y: 180.7,
    width: 4.4,
    height: 14.7,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.38,
    y: 180.7,
    width: 4.4,
    height: 14.7,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 628.08,
    y: 180.7,
    width: 4.4,
    height: 14.7,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.79,
    y: 180.7,
    width: 4.4,
    height: 14.7,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.49,
    y: 180.7,
    width: 4.4,
    height: 14.7,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 652.18,
    y: 177.42,
    width: 23.42,
    height: 21.26,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 655.47,
    y: 180.7,
    width: 3.75,
    height: 14.7,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 662.02,
    y: 180.7,
    width: 3.75,
    height: 14.7,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668.57,
    y: 180.7,
    width: 3.75,
    height: 14.7,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 652.18,
    y: 198.68,
    width: 35.03,
    height: 211.34,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.45,
    y: 166.64,
    width: 1.58,
    height: 10.77,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.84,
    y: 166.64,
    width: 1.58,
    height: 10.77,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.47,
    y: 147.81,
    width: 45.93,
    height: 18.84,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597.7,
    y: 213.23,
    width: 12.7,
    height: 19.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.56,
    y: 213.23,
    width: 12.7,
    height: 19.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597.7,
    y: 243.89,
    width: 12.7,
    height: 19.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.56,
    y: 243.89,
    width: 12.7,
    height: 19.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597.7,
    y: 274.54,
    width: 12.7,
    height: 19.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.56,
    y: 274.54,
    width: 12.7,
    height: 19.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597.7,
    y: 305.2,
    width: 12.7,
    height: 19.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.56,
    y: 305.2,
    width: 12.7,
    height: 19.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597.7,
    y: 335.86,
    width: 12.7,
    height: 19.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.56,
    y: 335.86,
    width: 12.7,
    height: 19.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597.7,
    y: 366.51,
    width: 12.7,
    height: 19.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.56,
    y: 366.51,
    width: 12.7,
    height: 19.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.62,
    y: 213.23,
    width: 7.3,
    height: 19.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 673.48,
    y: 213.23,
    width: 7.3,
    height: 19.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.62,
    y: 243.89,
    width: 7.3,
    height: 19.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 673.48,
    y: 243.89,
    width: 7.3,
    height: 19.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.62,
    y: 274.54,
    width: 7.3,
    height: 19.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 673.48,
    y: 274.54,
    width: 7.3,
    height: 19.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.62,
    y: 305.2,
    width: 7.3,
    height: 19.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 673.48,
    y: 305.2,
    width: 7.3,
    height: 19.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.62,
    y: 335.86,
    width: 7.3,
    height: 19.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 673.48,
    y: 335.86,
    width: 7.3,
    height: 19.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.62,
    y: 366.51,
    width: 7.3,
    height: 19.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 673.48,
    y: 366.51,
    width: 7.3,
    height: 19.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.19,
    y: 125.12,
    width: 43.53,
    height: 284.9,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.19,
    y: 141.08,
    width: 43.53,
    height: 2.99,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.68,
    y: 152.87,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.68,
    y: 173.89,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.68,
    y: 194.91,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.68,
    y: 215.91,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.68,
    y: 236.93,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.68,
    y: 257.95,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.68,
    y: 278.95,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.68,
    y: 299.97,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.68,
    y: 320.99,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.68,
    y: 341.99,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.68,
    y: 363.01,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.68,
    y: 384.03,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.68,
    y: 152.87,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.68,
    y: 173.89,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.68,
    y: 194.91,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.68,
    y: 215.91,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.68,
    y: 236.93,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.68,
    y: 257.95,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.68,
    y: 278.95,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.68,
    y: 299.97,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.68,
    y: 320.99,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.68,
    y: 341.99,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.68,
    y: 363.01,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.68,
    y: 384.03,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.95,
    y: 152.87,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.95,
    y: 173.89,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.95,
    y: 194.91,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.95,
    y: 215.91,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.95,
    y: 236.93,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.95,
    y: 257.95,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.95,
    y: 278.95,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.95,
    y: 299.97,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.95,
    y: 320.99,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.95,
    y: 341.99,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.95,
    y: 363.01,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.95,
    y: 384.03,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.95,
    y: 152.87,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.95,
    y: 173.89,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.95,
    y: 194.91,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.95,
    y: 215.91,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.95,
    y: 236.93,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.95,
    y: 257.95,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.95,
    y: 278.95,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.95,
    y: 299.97,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.95,
    y: 320.99,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.95,
    y: 341.99,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.95,
    y: 363.01,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.95,
    y: 384.03,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.22,
    y: 152.87,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.22,
    y: 173.89,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.22,
    y: 194.91,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.22,
    y: 215.91,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.22,
    y: 236.93,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.22,
    y: 257.95,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.22,
    y: 278.95,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.22,
    y: 299.97,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.22,
    y: 320.99,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.22,
    y: 341.99,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.22,
    y: 363.01,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.22,
    y: 384.03,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.22,
    y: 152.87,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.22,
    y: 173.89,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.22,
    y: 194.91,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.22,
    y: 215.91,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.22,
    y: 236.93,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.22,
    y: 257.95,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.22,
    y: 278.95,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.22,
    y: 299.97,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.22,
    y: 320.99,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.22,
    y: 341.99,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.22,
    y: 363.01,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.22,
    y: 384.03,
    width: 8.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.78,
    y: 125.12,
    width: 74.41,
    height: 284.9,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.78,
    y: 141.08,
    width: 74.41,
    height: 2.99,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.31,
    y: 109.11,
    width: 47.89,
    height: 16.01,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.19,
    y: 109.11,
    width: 22.5,
    height: 16.01,
    transform: "translate(296.89 234.23) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.76,
    y: 152.87,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.76,
    y: 173.89,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.76,
    y: 194.91,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.76,
    y: 215.91,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.76,
    y: 236.93,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.76,
    y: 257.95,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.76,
    y: 278.95,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.76,
    y: 299.97,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.76,
    y: 320.99,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.76,
    y: 341.99,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.76,
    y: 363.01,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.76,
    y: 384.03,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.76,
    y: 152.87,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.76,
    y: 173.89,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.76,
    y: 194.91,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.76,
    y: 215.91,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.76,
    y: 236.93,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.76,
    y: 257.95,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.76,
    y: 278.95,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.76,
    y: 299.97,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.76,
    y: 320.99,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.76,
    y: 341.99,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.76,
    y: 363.01,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.76,
    y: 384.03,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 152.87,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 173.89,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 194.91,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 215.91,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 236.93,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 257.95,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 278.95,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 299.97,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 320.99,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 341.99,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 363.01,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 384.03,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 152.87,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 173.89,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 194.91,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 215.91,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 236.93,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 257.95,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 278.95,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 299.97,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 320.99,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 341.99,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 363.01,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.3,
    y: 384.03,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 152.87,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 173.89,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 194.91,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 215.91,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 236.93,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 257.95,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 278.95,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 299.97,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 320.99,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 341.99,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 363.01,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 384.03,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 152.87,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 173.89,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 194.91,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 215.91,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 236.93,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 257.95,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 278.95,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 299.97,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 320.99,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 341.99,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 363.01,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 384.03,
    width: 13.01,
    height: 16.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.05,
    y: 180.66,
    width: 45.37,
    height: 229.36,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.05,
    y: 180.66,
    width: 45.37,
    height: 229.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.05,
    y: 173.14,
    width: 48.08,
    height: 7.52,
    transform: "translate(1092.19 353.8) rotate(180)",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.05,
    y: 161.41,
    width: 40.76,
    height: 11.73,
    transform: "translate(1084.87 334.55) rotate(180)",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.05,
    y: 161.41,
    width: 40.76,
    height: 11.73,
    transform: "translate(1084.87 334.55) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.05,
    y: 135.53,
    width: 31.19,
    height: 25.88,
    transform: "translate(1075.29 296.94) rotate(180)",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.05,
    y: 135.53,
    width: 31.19,
    height: 25.88,
    transform: "translate(1075.29 296.94) rotate(180)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 526.4,
    y: 189.35,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 526.4,
    y: 222.22,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 526.4,
    y: 255.08,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 526.4,
    y: 287.95,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 526.4,
    y: 320.81,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 526.4,
    y: 353.68,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 536.57,
    y: 189.35,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 536.57,
    y: 222.22,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 536.57,
    y: 255.08,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 536.57,
    y: 287.95,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 536.57,
    y: 320.81,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 536.57,
    y: 353.68,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 546.75,
    y: 189.35,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 546.75,
    y: 222.22,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 546.75,
    y: 255.08,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 546.75,
    y: 287.95,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 546.75,
    y: 320.81,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 546.75,
    y: 353.68,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 556.92,
    y: 189.35,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 556.92,
    y: 222.22,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 556.92,
    y: 255.08,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 556.92,
    y: 287.95,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 556.92,
    y: 320.81,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 556.92,
    y: 353.68,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 429.06,
    y: 180.66,
    width: 92.99,
    height: 229.36,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.52,
    y: 161.41,
    width: 88.54,
    height: 11.73,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455.43,
    y: 135.53,
    width: 66.62,
    height: 25.88,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455.43,
    y: 135.53,
    width: 66.62,
    height: 25.88,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.28,
    y: 173.14,
    width: 95.77,
    height: 7.52,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.28,
    y: 173.14,
    width: 95.77,
    height: 7.52,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 437.95,
    y: 189.35,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 437.95,
    y: 222.22,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 437.95,
    y: 255.08,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 437.95,
    y: 287.95,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 437.95,
    y: 320.81,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 437.95,
    y: 353.68,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 458.82,
    y: 189.35,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 458.82,
    y: 222.22,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 458.82,
    y: 255.08,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 458.82,
    y: 287.95,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 458.82,
    y: 320.81,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 458.82,
    y: 353.68,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 479.68,
    y: 189.35,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 479.68,
    y: 222.22,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 479.68,
    y: 255.08,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 479.68,
    y: 287.95,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 479.68,
    y: 320.81,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 479.68,
    y: 353.68,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 500.54,
    y: 189.35,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 500.54,
    y: 222.22,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 500.54,
    y: 255.08,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 500.54,
    y: 287.95,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 500.54,
    y: 320.81,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 500.54,
    y: 353.68,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 458.82,
    y: 387.28,
    width: 33.48,
    height: 22.73,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 615.13,
    y: 279.23,
    width: 45.37,
    height: 130.79,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 615.13,
    y: 279.23,
    width: 45.37,
    height: 130.79,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 615.13,
    y: 271.71,
    width: 48.08,
    height: 7.52,
    transform: "translate(1278.33 550.94) rotate(180)",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 615.13,
    y: 259.98,
    width: 40.76,
    height: 11.73,
    transform: "translate(1271.01 531.69) rotate(180)",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 615.13,
    y: 259.98,
    width: 40.76,
    height: 11.73,
    transform: "translate(1271.01 531.69) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 619.47,
    y: 287.92,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 619.47,
    y: 320.79,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 619.47,
    y: 353.65,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 629.65,
    y: 287.92,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 629.65,
    y: 320.79,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 629.65,
    y: 353.65,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 639.82,
    y: 287.92,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 639.82,
    y: 320.79,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 639.82,
    y: 353.65,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 649.99,
    y: 287.92,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 649.99,
    y: 320.79,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 649.99,
    y: 353.65,
    width: 6.15,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 522.14,
    y: 279.23,
    width: 92.99,
    height: 130.79,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526.59,
    y: 259.98,
    width: 88.54,
    height: 11.73,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.35,
    y: 271.71,
    width: 95.77,
    height: 7.52,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.35,
    y: 271.71,
    width: 95.77,
    height: 7.52,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 531.03,
    y: 287.92,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 531.03,
    y: 320.79,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 531.03,
    y: 353.65,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 551.89,
    y: 287.92,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 551.89,
    y: 320.79,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 551.89,
    y: 353.65,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 572.75,
    y: 287.92,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 572.75,
    y: 320.79,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 572.75,
    y: 353.65,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 593.61,
    y: 287.92,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 593.61,
    y: 320.79,
    width: 12.62,
    height: 24.12
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 593.61,
    y: 353.65,
    width: 12.62,
    height: 24.12
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Streetlights--inject-21"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "72.42 410.02 76.86 410.02 75.75 290.46 73.53 290.46 72.42 410.02",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.42 410.02 76.86 410.02 75.75 290.46 73.53 290.46 72.42 410.02",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.53 290.56 100.06 275.79 100.06 276.52 75.48 291.3 73.53 290.56",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.53 290.56 100.06 275.79 100.06 276.52 75.48 291.3 73.53 290.56",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.6 275.14 97.91 277.76 109.78 277.76 109.78 273.44 97.6 275.14",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.56 290.56 49.04 275.79 49.04 276.52 73.61 291.3 75.56 290.56",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.56 290.56 49.04 275.79 49.04 276.52 73.61 291.3 75.56 290.56",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.49 275.14 51.19 277.76 39.32 277.76 39.32 273.44 51.49 275.14",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.73 410.02 71.55 410.02 72.14 377.79 77.11 377.79 77.73 410.02",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.87 410.02 377.31 410.02 376.2 290.46 373.98 290.46 372.87 410.02",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.87 410.02 377.31 410.02 376.2 290.46 373.98 290.46 372.87 410.02",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.98 290.56 400.51 275.79 400.51 276.52 375.94 291.3 373.98 290.56",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.98 290.56 400.51 275.79 400.51 276.52 375.94 291.3 373.98 290.56",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.05 275.14 398.36 277.76 410.23 277.76 410.23 273.44 398.05 275.14",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.02 290.56 349.49 275.79 349.49 276.52 374.06 291.3 376.02 290.56",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.02 290.56 349.49 275.79 349.49 276.52 374.06 291.3 376.02 290.56",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.95 275.14 351.64 277.76 339.77 277.76 339.77 273.44 351.95 275.14",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.18 410.02 372 410.02 372.6 377.79 377.57 377.79 378.18 410.02",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "673.33 410.02 677.76 410.02 676.65 290.46 674.43 290.46 673.33 410.02",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "673.33 410.02 677.76 410.02 676.65 290.46 674.43 290.46 673.33 410.02",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "674.43 290.56 700.96 275.79 700.96 276.52 676.39 291.3 674.43 290.56",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "674.43 290.56 700.96 275.79 700.96 276.52 676.39 291.3 674.43 290.56",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "698.51 275.14 698.81 277.76 710.68 277.76 710.68 273.44 698.51 275.14",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "676.47 290.56 649.94 275.79 649.94 276.52 674.52 291.3 676.47 290.56",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "676.47 290.56 649.94 275.79 649.94 276.52 674.52 291.3 676.47 290.56",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "652.4 275.14 652.09 277.76 640.23 277.76 640.23 273.44 652.4 275.14",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "678.63 410.02 672.46 410.02 673.05 377.79 678.02 377.79 678.63 410.02",
    style: {
      fill: "#90CAF9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.39,365S71.58,392,51.68,392.05s-7-28-7-28-4.61-2,.72-17.13,7.71-15.12,9.93-15.12c2.8,0,5.42,6.53,3.52,16.57C58.82,348.37,65.83,360.9,59.39,365Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.94 410.02 51.81 369.21 53.77 410.01 49.94 410.02",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.05 386.32 58.27 377.86 52.61 387.44 51.05 386.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.21,367.87s-5.68-2.25-10.18,5.59c-4.61,8,1.19,13.33,5.78,10.18,0,0,3.61,7.56,10.82,5.75s8.36-7.58,8.36-7.58,6.4.45,6.58-4.33-4.52-9-4.52-9-.28-11.89-8-11.79S288.21,367.87,288.21,367.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.52 410 295.11 374.62 296.76 409.99 293.52 410",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.64 387.91 289.65 377.99 295.45 386.36 294.64 387.91",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.84,367.87s-5.68-2.25-10.17,5.59c-4.61,8,1.18,13.33,5.77,10.18,0,0,3.61,7.56,10.82,5.75s8.37-7.58,8.37-7.58,6.39.45,6.57-4.33-4.52-9-4.52-9-.28-11.89-8-11.79S192.84,367.87,192.84,367.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.16 410 199.74 374.62 201.4 409.99 198.16 410",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.27 387.91 194.29 377.99 200.09 386.36 199.27 387.91",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.22,364.78s12.19,27.07-7.71,27.09-7-28-7-28-4.6-2,.72-17.14,7.72-15.11,9.94-15.12c2.8,0,5.42,6.54,3.52,16.58C643.65,348.19,650.66,360.72,644.22,364.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "634.76 409.83 636.63 369.03 638.6 409.83 634.76 409.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "635.87 386.14 643.1 377.68 637.43 387.25 635.87 386.14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.82,364.78s12.19,27.07-7.71,27.09-7-28-7-28-4.61-2,.72-17.14,7.71-15.11,9.93-15.12c2.8,0,5.42,6.54,3.52,16.58C567.25,348.19,574.26,360.72,567.82,364.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "558.36 409.83 560.24 369.03 562.2 409.83 558.36 409.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "559.48 386.14 566.7 377.68 561.04 387.25 559.48 386.14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.84,370.53s-10.63,23.73,6.8,23.71,6.11-24.54,6.11-24.54,4-1.78-.66-15-6.79-13.23-8.73-13.23c-2.46,0-4.74,5.74-3.06,14.53C261.3,356,255.18,367,260.84,370.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.2 409.98 267.49 374.24 265.84 409.98 269.2 409.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.19 389.22 261.84 381.83 266.82 390.2 268.19 389.22",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,370.53s-10.62,23.73,6.81,23.71,6.11-24.54,6.11-24.54,4-1.78-.67-15-6.78-13.23-8.73-13.23c-2.45,0-4.73,5.74-3.05,14.53C418.49,356,412.37,367,418,370.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.39 409.98 424.67 374.24 423.03 409.98 426.39 409.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.37 389.22 419.03 381.83 424.01 390.2 425.37 389.22",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.73,367.72s-5.68-2.24-10.17,5.6c-4.61,8,1.18,13.33,5.77,10.17,0,0,3.62,7.56,10.82,5.75s8.37-7.57,8.37-7.57,6.4.44,6.57-4.33-4.51-9-4.51-9-.29-11.89-8-11.8S578.73,367.72,578.73,367.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "584.05 409.85 585.63 374.47 587.29 409.85 584.05 409.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "585.14 387.73 580.18 377.85 586.12 386.2 585.14 387.73",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-21"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.68,
    y: 464.65,
    width: 682.63,
    height: 7.27,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.54,464.65a7.85,7.85,0,0,1,.81,3.63,7.73,7.73,0,0,1-.81,3.63,7.73,7.73,0,0,1-.81-3.63A7.85,7.85,0,0,1,81.54,464.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.9,464.65a8.54,8.54,0,0,1,0,7.26,7.61,7.61,0,0,1-.81-3.63A7.73,7.73,0,0,1,134.9,464.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.25,464.65a7.73,7.73,0,0,1,.81,3.63,7.61,7.61,0,0,1-.81,3.63,8.54,8.54,0,0,1,0-7.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.61,464.65a7.85,7.85,0,0,1,.81,3.63,7.73,7.73,0,0,1-.81,3.63,7.73,7.73,0,0,1-.81-3.63A7.85,7.85,0,0,1,241.61,464.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,464.65a8.54,8.54,0,0,1,0,7.26,7.74,7.74,0,0,1-.82-3.63A7.86,7.86,0,0,1,295,464.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.32,464.65a7.73,7.73,0,0,1,.81,3.63,7.61,7.61,0,0,1-.81,3.63,7.73,7.73,0,0,1-.81-3.63A7.85,7.85,0,0,1,348.32,464.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.68,464.65a7.85,7.85,0,0,1,.81,3.63,7.73,7.73,0,0,1-.81,3.63,7.61,7.61,0,0,1-.81-3.63A7.73,7.73,0,0,1,401.68,464.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455,464.65a7.86,7.86,0,0,1,.82,3.63,7.74,7.74,0,0,1-.82,3.63,8.54,8.54,0,0,1,0-7.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.39,464.65a7.85,7.85,0,0,1,.81,3.63,7.73,7.73,0,0,1-.81,3.63,7.73,7.73,0,0,1-.81-3.63A7.85,7.85,0,0,1,508.39,464.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.75,464.65a8.54,8.54,0,0,1,0,7.26,7.61,7.61,0,0,1-.81-3.63A7.73,7.73,0,0,1,561.75,464.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.1,464.65a7.73,7.73,0,0,1,.81,3.63,7.61,7.61,0,0,1-.81,3.63,8.54,8.54,0,0,1,0-7.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.46,464.65a7.85,7.85,0,0,1,.81,3.63,7.73,7.73,0,0,1-.81,3.63,7.73,7.73,0,0,1-.81-3.63A7.85,7.85,0,0,1,668.46,464.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.19 471.92 118.64 471.67 204.1 471.58 375 471.42 545.9 471.58 631.36 471.67 716.81 471.92 631.36 472.16 545.9 472.25 375 472.41 204.1 472.25 118.64 472.16 33.19 471.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.19 410.02 118.64 409.77 204.1 409.68 375 409.52 545.9 409.68 631.36 409.77 716.81 410.02 631.36 410.26 545.9 410.35 375 410.51 204.1 410.35 118.64 410.26 33.19 410.02",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyimg);
export default __webpack_public_path__ + "static/media/companyimg.a0b3fcc29ebd5dc69f7388f81b6db64a.svg";
export { ForwardRef as ReactComponent };